import Phaser from "phaser";

export default class StartScene extends Phaser.Scene {
    constructor() {
        super("StartScene");
        this.background = null;
    }

    preload() {
        this.load.image("start-bg", "/CIOL_BG3.png");
    }

    create() {
        this.background = this.add.image(
            this.scale.width / 2,
            this.scale.height / 2,
            "start-bg"
        );

        this.background.setOrigin(0.5, 0.5);

        this.scale.on('resize', this.resizeBackground, this);
        this.resizeBackground();
    }

    resizeBackground() {
        if (!this.background) return;

        const { width, height } = this.scale;

        const imageWidth = this.background.width;
        const imageHeight = this.background.height;

        const scaleX = width / imageWidth;
        const scaleY = height / imageHeight;

        // use max → zoom in until it covers screen
        const scale = Math.max(scaleX, scaleY);

        this.background.setScale(scale);

        // center it
        this.background.setPosition(width / 2, height / 2);
    }
}
